import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import i18n from './pluguins/i18n';
import app from "./firebaseConfig/config";

let vueApp;
// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.config.productionTip = false
app.auth().onAuthStateChanged(async () => {
    if (!vueApp) {
        await app.auth().currentUser;
        vueApp = new Vue({
            router,
            i18n,
            store,
            render: h => h(App)
        }).$mount('#app')
    }
})




